import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { Line } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";

export const ProjectedOccupancyTrend = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [forecast_mix_chartData, setforecast_mix_chartData] = useState([]);
    const [SelectedView, setSelectedView] = useState("OCC");

    const [forecast_mix_chart_loader, setforecast_mix_chart_loader] = useState(false);
    const forecast_mix_chart = async () => {
        setforecast_mix_chart_loader(true)
        let customday = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.MONEY_CONTROL.FORECAST_MIX_CHART,
                body: {
                    "propertyCode": para?.propertyCode,
                },
            },
            false
        );

        let customdayresponse = apiResponse(false, customday);

        if (customdayresponse?.isValidate) {
            setforecast_mix_chartData(customdayresponse?.data?.data);
        }
        setforecast_mix_chart_loader(false)
    }

    useEffect(() => {
        if (api === 0) {
            setforecast_mix_chartData([{
                "propertyCode": "AC32AW",
                "year": 2025,
                "month": "Jan",
                "month_no": 1,

                "occ_spider": "0",
                "occ_user": "0",
                "occ_nova": "0",

                "avg_occ": "0",
                "max_occ": "0",
                "min_occ": "0",

                "adr_spider": "0",
                "adr_user": "0",
                "adr_nova": "0",

                "avg_adr": "0",
                "max_adr": "0",
                "min_adr": "0",


                "rms_spider": "0",
                "rms_user": "0",
                "rms_nova": "0",

                "avg_rms": "0",
                "max_rms": "0",
                "min_rms": "0",

                "rev_spider": "0",
                "rev_user": "0",
                "rev_nova": "0",

                "avg_rev": "0",
                "max_rev": "0",
                "min_rev": "0"
            }, {
                "propertyCode": "AC32AW",
                "year": 2025,
                "month": "Feb",
                "month_no": 1,

                "occ_spider": "0",
                "occ_user": "0",
                "occ_nova": "0",

                "avg_occ": "0",
                "max_occ": "0",
                "min_occ": "0",

                "adr_spider": "0",
                "adr_user": "0",
                "adr_nova": "0",

                "avg_adr": "0",
                "max_adr": "0",
                "min_adr": "0",


                "rms_spider": "0",
                "rms_user": "0",
                "rms_nova": "0",

                "avg_rms": "0",
                "max_rms": "0",
                "min_rms": "0",

                "rev_spider": "0",
                "rev_user": "0",
                "rev_nova": "0",

                "avg_rev": "0",
                "max_rev": "0",
                "min_rev": "0"
            }, {
                "propertyCode": "AC32AW",
                "year": 2025,
                "month": "Mar",
                "month_no": 1,

                "occ_spider": "0",
                "occ_user": "0",
                "occ_nova": "0",

                "avg_occ": "0",
                "max_occ": "0",
                "min_occ": "0",

                "adr_spider": "0",
                "adr_user": "0",
                "adr_nova": "0",

                "avg_adr": "0",
                "max_adr": "0",
                "min_adr": "0",


                "rms_spider": "0",
                "rms_user": "0",
                "rms_nova": "0",

                "avg_rms": "0",
                "max_rms": "0",
                "min_rms": "0",

                "rev_spider": "0",
                "rev_user": "0",
                "rev_nova": "0",

                "avg_rev": "0",
                "max_rev": "0",
                "min_rev": "0"
            },
            {
                "propertyCode": "AC32AW",
                "year": 2025,
                "month": "Apr",
                "month_no": 1,

                "occ_spider": "0",
                "occ_user": "0",
                "occ_nova": "0",

                "avg_occ": "0",
                "max_occ": "0",
                "min_occ": "0",

                "adr_spider": "0",
                "adr_user": "0",
                "adr_nova": "0",

                "avg_adr": "0",
                "max_adr": "0",
                "min_adr": "0",


                "rms_spider": "0",
                "rms_user": "0",
                "rms_nova": "0",

                "avg_rms": "0",
                "max_rms": "0",
                "min_rms": "0",

                "rev_spider": "0",
                "rev_user": "0",
                "rev_nova": "0",

                "avg_rev": "0",
                "max_rev": "0",
                "min_rev": "0"
            }])
        } else {
            if (para?.propertyCode) {
                forecast_mix_chart();
            }
        }
    }, [para?.propertyCode]);



    const [ChartOption, setChartOption] = useState(null);
    const [ChartData, setChartData] = useState(null);

    useEffect(() => {

        let labels = [];
        let AVGData = [];
        let MaxData = [];
        let MinData = [];

        let MinDataSrc = [];
        let MaxDataSrc = [];



        if (forecast_mix_chartData) {
            for (let i = 0; i < forecast_mix_chartData.length; i++) {
                labels.push(forecast_mix_chartData[i].month.substring(0, 3) + " " + forecast_mix_chartData[i].year)
                if (SelectedView === "OCC") {
                    AVGData.push(parseInt(forecast_mix_chartData[i].avg_occ))
                    MaxData.push(parseInt(forecast_mix_chartData[i].max_occ))
                    MinData.push(parseInt(forecast_mix_chartData[i].min_occ))

                    MinDataSrc.push(forecast_mix_chartData[i].min_occ_src)
                    MaxDataSrc.push(forecast_mix_chartData[i].max_occ_src)

                }
                else if (SelectedView === "ADR") {
                    AVGData.push(parseInt(forecast_mix_chartData[i].avg_adr))
                    MaxData.push(parseInt(forecast_mix_chartData[i].max_adr))
                    MinData.push(parseInt(forecast_mix_chartData[i].min_adr))

                    MinDataSrc.push(forecast_mix_chartData[i].min_adr_src)
                    MaxDataSrc.push(forecast_mix_chartData[i].max_adr_src)
                }
                else if (SelectedView === "RMS") {
                    AVGData.push(parseInt(forecast_mix_chartData[i].avg_rms))
                    MaxData.push(parseInt(forecast_mix_chartData[i].max_rms))
                    MinData.push(parseInt(forecast_mix_chartData[i].min_rms))

                    MinDataSrc.push(forecast_mix_chartData[i].min_rms_src)
                    MaxDataSrc.push(forecast_mix_chartData[i].max_rms_src)
                }
                else if (SelectedView === "REV") {
                    AVGData.push(parseInt(forecast_mix_chartData[i].avg_rev))
                    MaxData.push(parseInt(forecast_mix_chartData[i].max_rev))
                    MinData.push(parseInt(forecast_mix_chartData[i].min_rev))

                    MinDataSrc.push(forecast_mix_chartData[i].min_rev_src)
                    MaxDataSrc.push(forecast_mix_chartData[i].max_rev_src)
                }
            }
        }

        let _ChartOption = {
            responsive: true,
            plugins: {
                title: {
                    display: false,
                },
                legend: {
                    position: 'top',
                    labels: {
                        filter: function (legendItem, chartData) {
                            return false;
                        }
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            const label = context.label || "";
                            const value = context.raw;
                            return `${label}: ${(SelectedView !== "OCC" && SelectedView !== "RMS" ? propertyDetailFromRTK?.currency_term : "") + value}`;
                        },
                        footer: function (context) {
                            let Min = "";
                            if (MinDataSrc && MinDataSrc.length >= context[0].dataIndex) {
                                Min = MinDataSrc[context[0].dataIndex]
                            }
                            let Max = "";
                            if (MaxDataSrc && MaxDataSrc.length >= context[0].dataIndex) {
                                Max = MaxDataSrc[context[0].dataIndex]
                            }

                            return "Max source : " + Max + " (" + (SelectedView !== "OCC" && SelectedView !== "RMS" ? propertyDetailFromRTK?.currency_term : "") + context[0].formattedValue + ")\nMin source : " + Min + " (" + (SelectedView !== "OCC" && SelectedView !== "RMS" ? propertyDetailFromRTK?.currency_term : "") +context[2].formattedValue + ")"
                        },
                    }
                }
            },
            interaction: {
                mode: 'index',
                intersect: false
            },
            scales: {
                x: {
                    display: true,
                    title: {
                        display: false,
                        text: 'Month And Year'
                    }
                },
                y: {
                    display: true,
                    title: {
                        display: true,
                        text: SelectedView
                    }
                }
            }
        }

        let _Data = {
            labels: labels,
            datasets: [
                {
                    label: 'Max ' + SelectedView,
                    backgroundColor: "#118dff30",
                    borderColor: "#118dff30",
                    data: MaxData,
                    fill: "+2",
                    radius: 0,
                    borderWidth: 0
                }, {
                    label: 'Avg ' + SelectedView,
                    fill: false,
                    backgroundColor: "#118dff",
                    borderColor: "#118dff",
                    borderDash: [5, 5],
                    data: AVGData,
                }, {
                    label: 'Min ' + SelectedView,
                    backgroundColor: "#118dff30",
                    borderColor: "#118dff30",
                    data: MinData,
                    radius: 0,
                    borderWidth: 0

                }
            ]
        }

        setChartData(_Data);
        setChartOption(_ChartOption);
    }, [SelectedView, forecast_mix_chartData]);


    return (
        <div className="widget-container" style={{position: "relative"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("ProjectedOccupancyTrend", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.ProjectedOccupancyTrend,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>

                </div>
            )}
            <Row>
                <div className="form-groups form-groups-radio-btn">
                    <div className="form-groups-radio">
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="OCC"
                                id="OCC"
                                checked={SelectedView === "OCC" ? true : false}
                                onClick={() => {
                                    setSelectedView("OCC");
                                }}
                            />
                            <Form.Check.Label htmlFor="OCC" className="label-radio">
                                OCC
                            </Form.Check.Label>
                        </div>
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="ADR"
                                id="ADR"
                                checked={SelectedView === "ADR" ? true : false}
                                onClick={() => {
                                    setSelectedView("ADR");

                                }}
                            />
                            <Form.Check.Label
                                htmlFor="ADR"
                                className="label-radio"
                            >
                                ADR
                            </Form.Check.Label>
                        </div>
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="RMS"
                                id="RMS"
                                checked={SelectedView === "RMS" ? true : false}
                                onClick={() => {
                                    setSelectedView("RMS");

                                }}
                            />
                            <Form.Check.Label
                                htmlFor="RMS"
                                className="label-radio"
                            >
                                RMS
                            </Form.Check.Label>
                        </div>
                        <div className="form-radio">
                            <input
                                type="radio"
                                className="form-check-input"
                                name="radioGroup2"
                                value="REV"
                                id="REV"
                                checked={SelectedView === "REV" ? true : false}
                                onClick={() => {
                                    setSelectedView("REV");

                                }}
                            />
                            <Form.Check.Label
                                htmlFor="REV"
                                className="label-radio"
                            >
                                REV
                            </Form.Check.Label>
                        </div>
                    </div>
                </div>
            </Row>
            <div>
                {
                    forecast_mix_chart_loader ?
                        <Loader />
                        :
                        <>{ChartData && ChartOption && <Line data={ChartData} options={ChartOption} />}</>
                }
            </div>
            {api !== 0 && <Comments widgetDetails={para} editorId={"ProjectedOccupancyTrend"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};


export default ProjectedOccupancyTrend;
